import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { DomainSearchResponse } from "@/types/api";

/**
 * Real-time domain search against the live 20i `/domain-search` endpoint
 * (proxied through /api/domains/search). Implemented as a mutation rather
 * than a query so it only fires when the user explicitly searches — the
 * 20i endpoint is rate-limited, so we don't want it running on every
 * keystroke.
 */
export function useDomainSearch() {
  return useMutation({
    mutationFn: (query: string) =>
      api.get<DomainSearchResponse>(
        `/api/domains/search?q=${encodeURIComponent(query.trim())}`
      )
  });
}
